import React, { useState, useEffect, useRef } from 'react';
import BurgerIcon from './Burger';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';

const Header = () => {
  const navigate = useNavigate();
  const [isMenuVisible, setIsMenuVisible] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const lastScrollY = useRef(0);
  const threshold = 80; 

  useEffect(() => {
    document.body.style.overflow = isMenuVisible ? 'hidden' : 'auto';
  }, [isMenuVisible]);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY < threshold) {
        setIsVisible(true); 
      } else {
        if (currentScrollY > lastScrollY.current) {
          setIsVisible(false); 
        } else {
          setIsVisible(true); 
        }
      }

      setIsScrolled(currentScrollY > 0);
      lastScrollY.current = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuVisible(prev => !prev);
  };

  const handleLinkClick = () => {
    setIsMenuVisible(false); // Zamknięcie menu po kliknięciu w link
  };

  return (
    <header
      className={classNames(
        'fixed top-0 left-0 w-full z-[300] flex flex-row items-center justify-center transition-all duration-500 ease-in-out mq450:py-[12px]',
        {
          '-translate-y-full pointer-events-none': !isVisible,
          'translate-y-0': isVisible,
          'bg-transparent py-[24px] h-[48px]': !isScrolled,
          'bg-[#939ACB] py-[24px] h-[40px] z-[100]': isScrolled,
        }
      )}
    >
      <div className="flex flex-row max-w-[1280px] px-10 mq450:px-[16px] w-full justify-between items-center">
        {/* Logo */}
        <div className='flex justify-start w-[256px] mq450:w-auto'>
        <img
          onClick={() => { window.location.href = "#home"; }}
          src="/evera-logo.svg"
          className="h-[28px] mq450:h-[24px] cursor-pointer"
          alt="Logo"
        />
        </div>

        {/* Desktop nav */}
        <div id="nav-desktop" className="font-silka-light font-[400] flex flex-row gap-[48px] items-center mq450:hidden text-white">
          <a href="#onas" className="text-[16px] font-silka-light tracking-[0.05em] no-underline visited:text-[unset] text-white">O nas</a>
          <a href="#suple" className="text-[16px] font-silka-light tracking-[0.05em] no-underline visited:text-[unset] text-white">Suplementy</a>
          <a href="#sklad" className="text-[16px] font-silka-light tracking-[0.05em] no-underline visited:text-[unset] text-white">Skład</a>
          <a href="#opinie" className="text-[16px] font-silka-light tracking-[0.05em] no-underline visited:text-[unset] text-white">Opinie</a>
          <a href="#faq" className="text-[16px] font-silka-light tracking-[0.05em] no-underline visited:text-[unset] text-white">FAQ</a>
        </div>
        <div className='flex justify-end w-[256px]'>
        <div onClick={() => window.open('', '_blank')} className="flex px-[20px]  mq450:hidden items-center justify-center h-[48px] text-[16px] text-white bg-[#362F5B] rounded-full font-silka-light font-[400] tracking-[0.05em] no-underline cursor-pointer">
          Umów spotkanie
          </div>
          </div>

        {/* Burger menu */}
        <BurgerIcon toggleMenu={toggleMenu} isMenuVisible={isMenuVisible} className="z-[400]" />
      </div>

      {/* Mobile menu */}
      <div id="navbar-mobile"
        className={classNames(
          'fixed top-0 left-0 max-w-full w-full h-screen z-10 flex flex-col bg-[#939ACB] transition-all',
          { '-translate-y-full': !isMenuVisible, 'translate-y-0': isMenuVisible }
        )}
      >
        <div className="flex flex-col items-center text-[#232D46] text-[20px] justify-center gap-12 px-[16px] pt-[80px]">
          <img src="/evera-logo.svg" className="mq1440:h-[160px] mq450:h-[48px] z-[500]" alt="Logo Dark" />
          
          {/* Mobile links */}
          <div className="flex flex-col gap-8 items-center w-full text-white">
            <a href="#onas" className="text-[16px] font-silka-light tracking-[0.05em] no-underline visited:text-[unset] text-white" onClick={handleLinkClick}>O nas</a>
            <a href="#suple" className="text-[16px] font-silka-light tracking-[0.05em] no-underline visited:text-[unset] text-white" onClick={handleLinkClick}>Suplementy</a>
            <a href="#sklad" className="text-[16px] font-silka-light tracking-[0.05em] no-underline visited:text-[unset] text-white" onClick={handleLinkClick}>Skład</a>
            <a href="#opinie" className="text-[16px] font-silka-light tracking-[0.05em] no-underline visited:text-[unset] text-white" onClick={handleLinkClick}>Opinie</a>
            <a href="#faq" className="text-[16px] font-silka-light tracking-[0.05em] no-underline visited:text-[unset] text-white" onClick={handleLinkClick}>FAQ</a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
